<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Notifications.Title' | translate}}</h2>
  </div>
</div>

<div class="row">
  <!--E-mail-->
  <div class="col-sm-8">
    <div class="form-group">
      <label for="emailNotification"  [class.disabled]="(isFieldDisabled('emailNotification') && !isServiceOrFunerary) || IsStateIndeferida()">
        <span class="mandatory" >*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Notifications.Fields.NotificationEmail' | translate}}
        <button type="button"
                disabled
                class="btn-icon text-primary icon-help"
                aria-label="Tooltip com informação"
                tooltip="{{'Tooltips.CardSubscriberContacts.Email' | translate}}"></button>
      </label>
      <fieldset [disabled]="(isFieldDisabled('emailNotification') && !isServiceOrFunerary) || IsStateIndeferida()">
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="cardData.emailNotification"
                 #emailNotification="ngModel" name="emailNotification"
                 #email="ngModel" maxlength="60" email pattern="^.+@.+\..+$"
                 placeholder="{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.Notifications.Fields.NotificationEmailPlaceholder' | translate}}"
                 [required]="!((isFieldDisabled('emailNotification') && !isServiceOrFunerary) || IsStateIndeferida())"
                 [disabled]="(isFieldDisabled('emailNotification') && !isServiceOrFunerary) || IsStateIndeferida()"
                 messageFieldType="string">

          <validation-message [control]="emailNotification"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>
</div>

